import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { useCollectionStats } from '../hooks/useCollectionStats';

export default function Overview() {
  const { collectionId, collection } = useOutletContext();
  const { artworks_total, artworks_accepted, artists_total, loading } = useCollectionStats(collectionId);
  return (
    <div>
      <h2>Overview</h2>
      <div style={{ marginBottom: '1rem', color: '#64748b' }}>
        <div><strong>ID:</strong> {collectionId}</div>
        {collection?.featured && <div style={{ display: 'inline-block', background: '#fde68a', color: '#92400e', padding: '2px 8px', borderRadius: 6, marginTop: 6 }}>Featured</div>}
      </div>
      {collection?.description && (
        <p style={{ maxWidth: 800 }}>{collection.description}</p>
      )}
      <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem', flexWrap: 'wrap' }}>
        <div style={{ padding: '0.75rem 1rem', background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 8 }}>Artworks: {loading ? '…' : artworks_total}</div>
        <div style={{ padding: '0.75rem 1rem', background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 8 }}>Artists: {loading ? '…' : artists_total}</div>
        <div style={{ padding: '0.75rem 1rem', background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 8 }}>Accepted: {loading ? '…' : artworks_accepted}</div>
      </div>
    </div>
  );
}
